import React, { useState, useEffect } from 'react';
import { Button, Modal, message } from 'antd';

const ConfirmModal = ({ visible, closeModal, handleOk }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        setIsModalOpen(visible);
    }, [visible]);



    const handleCancel = () => {
        setIsModalOpen(false);
        closeModal();
    };

    return (
        <Modal
            title="Locomotive Status Update"
            visible={isModalOpen}
            className='customModal'
            okText="Confirm"
            bodyStyle={{ style: { background: 'white !important' } }}
            titleProps={{ style: { background: 'white', fontWeight: 'bold !important' } }}
            onCancel={handleCancel}  // Specify the handleCancel function for the close button

            footer={null}
        >
            <div>
                Do you want to release this locomotive back into service
            </div>
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <Button style={{ backgroundColor: '#285aad', color: 'white' }} onClick={() => handleOk()}>
                    Yes
                </Button>
                <Button style={{ marginLeft: '5px' }} onClick={handleCancel}>
                    No
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
